import {AvdbPricingProduct} from "./avdb-pricing-product";

export class AvdbPricingRankedProduct {
	constructor(public product: AvdbPricingProduct, public rank: number = 0) {}

	static RANK_INCREASE_FOR_PARTIAL_MAP_COVERAGE = 1;
	static RANK_INCREASE_FOR_COMPLETE_MAP_COVERAGE = 2;
	static RANK_INCREASE_FOR_HELICOPTER_SPECIFIC_DB = 1;
}
